import type { NewsItem } from "@/types";

export const newsList: NewsItem[] = [
  {
    id: "n1",
    title: "榴莲视频独家上线《星际回响》4K 修复版，太空叙事再引热议",
    summary:
      "备受好评的科幻电影《星际回响》在榴莲视频独家上线 4K 修复版，画面与音效全面升级，上线首日即登上站内热度榜首。",
    content: [
      "备受好评的科幻电影《星际回响》今日在榴莲视频独家上线 4K 修复版。此次修复版对太空场景的暗部细节与星云色彩进行了重新调色，配合全新的沉浸式音效，让观众几乎能听见宇宙的呼吸。",
      "影片讲述天体物理学家陆离在被重新点亮的信号中追寻人类孤独记忆的故事。导演陈焱表示，修复版的初衷是希望观众在更细腻的画面里，重新感受那段跨越星系的追问。",
      "上线首日，《星际回响》便登上榴莲视频站内热度榜首，相关话题也持续在影视社区发酵。不少观众表示，修复版让几处关键的情感段落更有冲击力。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20space%20scene%20with%20a%20spaceship%20and%20colorful%20nebula%2C%20deep%20purple%20and%20amber%20tones%2C%20editorial%20film%20news%20style%2C%20high%20detail&width=600&height=400&seq=ld-news-n1&orientation=landscape",
    inlineImage:
      "https://readdy.ai/api/search-image?query=astronaut%20looking%20at%20a%20glowing%20planet%20through%20a%20spacecraft%20window%2C%20deep%20purple%20and%20warm%20orange%20lighting%2C%20cinematic%20sci-fi%20editorial%20image&width=800&height=450&seq=ld-news-n1-in&orientation=landscape",
    date: "2025-10-09",
    source: "榴莲影视编辑部",
    author: "编辑部",
    category: "资讯",
    tags: ["星际回响", "科幻", "4K修复"],
    relatedMediaId: "m1",
  },
  {
    id: "n2",
    title: "《长安夜行》口碑逆袭：古装权谋为何又一次霸屏",
    summary:
      "开播初期不被看好的《长安夜行》，凭借扎实的剧本与群像表演口碑持续走高，成为本季最受关注的古装剧。",
    content: [
      "《长安夜行》在开播前并不被市场看好，但短短两周，它却以扎实的剧本、克制的美术和出色的群像表演完成了口碑逆袭。",
      "剧集将叙事重心放在夜色中的追查与人物之间的试探上，节奏沉稳，克制却有力。观众讨论最多的，是剧中每一个配角都有自己的立场与代价。",
      "有分析认为，古装权谋题材的再次走红，说明观众对扎实叙事与人物弧光的需求从未消失。只要故事立得住，类型从来不是限制。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=ancient%20chinese%20city%20street%20at%20night%20with%20lanterns%20and%20mist%2C%20deep%20purple%20sky%20with%20warm%20orange%20lantern%20light%2C%20editorial%20drama%20news%20style&width=600&height=400&seq=ld-news-n2&orientation=landscape",
    inlineImage:
      "https://readdy.ai/api/search-image?query=ancient%20chinese%20official%20figure%20in%20robes%20standing%20in%20a%20lantern%20lit%20courtyard%20at%20night%2C%20deep%20purple%20and%20warm%20orange%20tones%2C%20cinematic%20editorial%20image&width=800&height=450&seq=ld-news-n2-in&orientation=landscape",
    date: "2025-10-07",
    source: "榴莲影视编辑部",
    author: "资深编辑 何知夏",
    category: "剧评",
    tags: ["长安夜行", "古装", "剧评"],
    relatedMediaId: "t1",
  },
  {
    id: "n3",
    title: "2025 片单前瞻：五部值得期待的科幻电影",
    summary:
      "从硬核太空到赛博都市，我们梳理了接下来最值得关注的五部科幻电影，以及它们各自的技术看点。",
    content: [
      "2025 年依然是科幻电影的丰收之年。从硬核太空叙事到赛博都市寓言，创作者们正在用越来越成熟的工业化手段，把想象力搬上大银幕。",
      "《星际回响》之后，多部作品都在探索同一件事：当技术足够炫目时，故事还能不能守住人本身。这或许才是科幻真正的试金石。",
      "我们也整理了这几部影片在美术、特效与声音设计上的差异，帮助你在观影前先建立一份属于自己的期待清单。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=futuristic%20city%20skyline%20with%20hover%20vehicles%20at%20dusk%2C%20deep%20purple%20and%20orange%20neon%20tones%2C%20editorial%20sci-fi%20news%20style&width=600&height=400&seq=ld-news-n3&orientation=landscape",
    inlineImage:
      "https://readdy.ai/api/search-image?query=cyberpunk%20street%20with%20glowing%20neon%20signs%20and%20rain%2C%20deep%20purple%20and%20orange%20lighting%2C%20cinematic%20editorial%20image&width=800&height=450&seq=ld-news-n3-in&orientation=landscape",
    date: "2025-10-05",
    source: "榴莲影视编辑部",
    author: "编辑部",
    category: "前瞻",
    tags: ["科幻", "片单", "前瞻"],
    relatedMediaId: "m4",
  },
  {
    id: "n4",
    title: "《雾都谜案》确定续订第二季，主创回应结局争议",
    summary:
      "口碑佳作《雾都谜案》正式确定续订第二季，主创团队在采访中回应了观众对结尾处留白的讨论。",
    content: [
      "悬疑剧《雾都谜案》凭借缜密的推理结构和阴冷迷人的氛围收获高口碑，近日正式确定续订第二季。",
      "对于观众热议的结尾留白，主创回应称，那不是没有答案，而是把回答的权利交还给了观众。真正的谜题，往往藏在人物的选择里。",
      "第二季将在保留原有视觉风格的基础上，引入全新的案件线与人物关系。制作团队表示，会继续以尊重观众智商的方式讲好每一个故事。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=foggy%20harbor%20street%20at%20night%20with%20dim%20street%20lamps%2C%20deep%20purple%20fog%20with%20orange%20glow%2C%20editorial%20mystery%20news%20style&width=600&height=400&seq=ld-news-n4&orientation=landscape",
    inlineImage:
      "https://readdy.ai/api/search-image?query=detective%20silhouette%20in%20thick%20fog%20lit%20by%20a%20street%20lamp%2C%20deep%20purple%20and%20amber%20tones%2C%20cinematic%20editorial%20image&width=800&height=450&seq=ld-news-n4-in&orientation=landscape",
    date: "2025-10-03",
    source: "榴莲影视编辑部",
    author: "资深编辑 何知夏",
    category: "资讯",
    tags: ["雾都谜案", "续订", "悬疑"],
    relatedMediaId: "t3",
  },
  {
    id: "n5",
    title: "综艺观察：户外竞技真人秀为何能持续出圈",
    summary:
      "从单纯的游戏比拼到真实的人际关系，户外竞技真人秀正在完成一次悄然的转型，也重新定义了观众对综艺的期待。",
    content: [
      "户外竞技真人秀并不新鲜，但近几年它的热度却在持续攀升。原因或许并不在于规则本身，而在于镜头开始更真诚地记录人。",
      "当嘉宾真的在极端环境里狼狈、协作、争吵又和好，观众获得的不只是笑点，还有一种久违的陪伴感。",
      "《极限挑战星球》正是这一转变的代表。它的胜负欲依然强烈，但真正留住观众的，是那些计划之外的瞬间。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=adventurers%20hiking%20on%20a%20dramatic%20mountain%20trail%20at%20golden%20hour%2C%20vivid%20orange%20and%20deep%20purple%20tones%2C%20editorial%20reality%20show%20news%20style&width=600&height=400&seq=ld-news-n5&orientation=landscape",
    inlineImage:
      "https://readdy.ai/api/search-image?query=group%20of%20hikers%20celebrating%20on%20a%20mountain%20peak%20under%20a%20sunset%20sky%2C%20vivid%20orange%20and%20deep%20purple%20tones%2C%20cinematic%20editorial%20image&width=800&height=450&seq=ld-news-n5-in&orientation=landscape",
    date: "2025-09-29",
    source: "榴莲影视编辑部",
    author: "编辑部",
    category: "观察",
    tags: ["综艺", "真人秀", "观察"],
    relatedMediaId: "v1",
  },
  {
    id: "n6",
    title: "《声生不息·宝藏季》收官，这些宝藏歌曲值得单曲循环",
    summary:
      "音乐竞演节目《声生不息·宝藏季》正式收官，节目不仅留下了许多高光舞台，也把一批被遗忘的宝藏歌曲重新带回大众视野。",
    content: [
      "当熟悉的旋律被重新编曲，被不同年代的嗓音唱出，时间仿佛在舞台上短暂地折叠了一次。",
      "《声生不息·宝藏季》最动人的地方，不是竞技的胜负，而是它愿意花时间，让一首老歌被重新听见。",
      "节目收官后，我们整理了几场最值得反复回看的高光舞台。或许其中某一首，正藏着你的某段记忆。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=grand%20concert%20stage%20with%20beams%20of%20light%20and%20haze%2C%20deep%20purple%20and%20warm%20orange%20spotlights%2C%20editorial%20music%20news%20style&width=600&height=400&seq=ld-news-n6&orientation=landscape",
    inlineImage:
      "https://readdy.ai/api/search-image?query=singer%20performing%20under%20a%20spotlight%20on%20a%20big%20stage%2C%20deep%20purple%20stage%20with%20warm%20orange%20beam%2C%20cinematic%20editorial%20image&width=800&height=450&seq=ld-news-n6-in&orientation=landscape",
    date: "2025-09-26",
    source: "榴莲影视编辑部",
    author: "音乐编辑 江声",
    category: "乐评",
    tags: ["音乐", "综艺", "乐评"],
    relatedMediaId: "v2",
  },
  {
    id: "n7",
    title: "《机械之心》特效幕后：一部赛博电影是怎样诞生的",
    summary:
      "从概念设计到镜头合成，《机械之心》的特效团队分享了如何用有限的预算，打造出一个可信的近未来都市。",
    content: [
      "在《机械之心》里，未来都市的霓虹与机械义体的冷光同样耀眼。但很少有人知道，这些画面背后是一套极其克制的制作逻辑。",
      "特效团队选择把预算集中压在几个关键镜头上，其余部分则依靠实景与美术搭建，让画面既有想象力，也保持真实的质感。",
      "“我们不追求炫技，只想让观众相信那个世界真的存在。”主创在采访中这样总结他们的取舍。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=cyberpunk%20studio%20with%20concept%20art%20panels%20and%20glowing%20screens%2C%20deep%20purple%20and%20orange%20tones%2C%20editorial%20behind%20the%20scenes%20style&width=600&height=400&seq=ld-news-n7&orientation=landscape",
    inlineImage:
      "https://readdy.ai/api/search-image?query=concept%20art%20of%20a%20futuristic%20city%20on%20a%20designer%20screen%20with%20glowing%20blueprint%20lines%2C%20deep%20purple%20and%20orange%20tones%2C%20cinematic%20editorial%20image&width=800&height=450&seq=ld-news-n7-in&orientation=landscape",
    date: "2025-09-22",
    source: "榴莲影视编辑部",
    author: "编辑部",
    category: "幕后",
    tags: ["机械之心", "特效", "幕后"],
    relatedMediaId: "m4",
  },
  {
    id: "n8",
    title: "影视资讯周报：本周值得关注的行业动态一览",
    summary:
      "从新片定档到平台片单发布，我们用一份周报帮你快速梳理本周影视行业的重要动态。",
    content: [
      "本周的影视行业依旧热闹：多部新片公布定档消息，几家平台也陆续释出了下一季度的片单。",
      "在题材上，科幻与悬疑依然占据主要位置，但生活流与家庭题材的回归同样值得留意。观众的口味正在变得更加多元。",
      "我们会持续跟进这些作品的最新进展，也欢迎你在评论区留下最想看到的那一部。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20collage%20of%20film%20strips%20and%20cinema%20elements%20on%20a%20dark%20table%2C%20deep%20purple%20and%20warm%20orange%20tones%2C%20modern%20film%20news%20style&width=600&height=400&seq=ld-news-n8&orientation=landscape",
    inlineImage:
      "https://readdy.ai/api/search-image?query=film%20reels%20and%20clapperboard%20on%20a%20producer%20desk%20with%20warm%20lighting%2C%20deep%20purple%20and%20orange%20tones%2C%20cinematic%20editorial%20image&width=800&height=450&seq=ld-news-n8-in&orientation=landscape",
    date: "2025-09-19",
    source: "榴莲影视编辑部",
    author: "编辑部",
    category: "周报",
    tags: ["资讯", "周报", "行业"],
    relatedMediaId: "m3",
  },
];